import HttpHelper from '@/helpers/http';
import { IStreamSettings, TLivePlatforms } from '@/helpers/user';

export default class StreamApi {
  static async getStreamSettingsByUuid(uuid): Promise<IStreamSettings> {
    return await HttpHelper.get(`/api/v1/users/streams/settings?uuid=${uuid}`);
  }

  static async getLastStreamSessionDestinations(): Promise<{platforms: TLivePlatforms[]}> {
    return await HttpHelper.get('/api/v1/users/me/stream/session/latest/platforms', { background: true });
  }
}
